var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "indicador-de-atividade",
      class: _vm.classes,
      style: _vm.estilo,
      attrs: {
        "data-modo": _vm.modo,
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        "data-teste": "indicador-de-atividade"
      }
    },
    [
      _c(
        "g",
        { staticClass: "indicador-de-atividade__orbita" },
        _vm._l(_vm.bracos, function(braco, i) {
          return _c(
            "g",
            {
              key: i,
              staticClass: "indicador-de-atividade__braco",
              attrs: { "data-teste": "indicador-braco" }
            },
            [
              _c("line", {
                staticClass: "indicador-de-atividade__linha",
                attrs: {
                  x1: "12",
                  y1: "12",
                  x2: braco.x,
                  y2: braco.y,
                  stroke: "currentColor",
                  "stroke-width": "1.1",
                  "stroke-linecap": "round"
                }
              }),
              _c("circle", {
                staticClass: "indicador-de-atividade__satelite",
                attrs: {
                  cx: braco.x,
                  cy: braco.y,
                  r: "2",
                  fill: "currentColor",
                  "data-teste": "indicador-satelite"
                }
              })
            ]
          )
        }),
        0
      ),
      _c("circle", {
        staticClass: "indicador-de-atividade__nucleo",
        attrs: {
          cx: "12",
          cy: "12",
          r: "3.1",
          fill: "currentColor",
          "data-teste": "indicador-nucleo"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }